define('responsive-gameday-tracking/src/js/lib/switchboard',['require','exports','module','message-service/message-service','./enums/events'],function (require, exports, module) {

    var MessageService = require("message-service/message-service"),
        TrackingEvents = require( "./enums/events" );

    var _app_name = "AtBat",
        Tracking;

    // function switchboard(data,evt){
    //     console.debug("Switchboard",arguments);
    //     MessageService.on("GDAppTracking",switchboard);
    // }   

    // // MessageService.on("GDAppTracking",switchboard);

    function track(isDynamicPageView, isUserGenerated, componentName, componentActivity, mediaProps) {
        var params = {
                pageName: "Major League Baseball: Gameday: Gameday",
                componentName : componentName,
                dynamic_component: _app_name + ": " + componentName,
                dynamic_componentAction: _app_name + ": " + componentName + ": " + componentActivity,
                isDynamic: isDynamicPageView
            };
        if (typeof mediaProps !== "undefined") $.extend(params, { async_media: mediaProps });

        MessageService.publish("GDAppTracking", params);
    }

    return {
        // consts (or facsimiles thereof)
        VIDEO_HIGHLIGHTS_PLAYLIST: "Video Highlights Playlist",
        PREMIUM_STATS: "Premium Stats",
        VIDEO_HIGHLIGHT_ALERT: "Video Highlight Alert",
        // public functions
        init: function() {
            MessageService.addListener(EventTypes.VIEW_READY, function setViewTrackable(e) {
                MessageService.removeListener(e.type, setViewTrackable);
                viewTrackable = true;
            });
        },

        track_launch_link: function ($link, isDynamicPageView, isUserGenerated, componentName, componentActivity) {
            track(isDynamicPageView, isUserGenerated, componentName, componentActivity);
            window.open($link, "_blank");
        },

        track_launch_click: function (isDynamicPageView, isUserGenerated, componentName) {
            track(isDynamicPageView, isUserGenerated, componentName, TrackingEvents.CLICK.LAUNCH);
        },
        /*
         * There's a lot of prepenning of the word 'Gameday' throughout
         * the tracking code. In gameday mini, it uses this call to override
         * that prepen so that the two are distinguishible in omniture.
         */
        set_app_name: function ($app_name) {
            _app_name = $app_name;
        },

        track_new_batter_event: function () { //
            track(true, false, "New Batter", "New Batter");
        },

        track_jingle: function ($jingle) { //
            track(false, false, "Jingle", "Jingle " + $jingle);
        },

        track_video_available: function () {
            track(false, true, TrackingEvents.HIGHLIGHTS, HIGHLIGHTS + " Viewed");
        },

        track_live_lookin_alert_click: function () {
            track(false, true, TrackingEvents.LIVE_LOOK_IN, "Live Look-In Click - 3D");
        },

        track_live_lookin_list_click: function () {
            track(false, true, TrackingEvents.LIVE_LOOK_IN, "Live Look-In Click - Video Tab");
        },

        track_live_lookin_view: function () {
            track(false, true, TrackingEvents.LIVE_LOOK_IN, "Live Look-In Launch");
        },

        track_live_lookin_available: function () {
            track(false, false, TrackingEvents.LIVE_LOOK_IN, "Alert");
        },

        track_recent_plays_share_to_facebook: function () {
            track(false, true, TrackingEvents.RECENT_PLAYS, "Facebook Share Click");
        },

        track_recent_plays_share_to_twitter: function () {
            track(false, true, TrackingEvents.RECENT_PLAYS, "Twitter Share Click");
        },

        /* Plays tab */
        track_plays_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.SUMMARY);
        },

        track_inning_click: function () {
            track(true, true, TrackingEvents.SUMMARY, "Inning Click");
        },

        track_scoring_plays_click: function () {
            track(true, true, TrackingEvents.SUMMARY, "Scoring Plays Click");
        },

        track_play_by_play_click: function () {
            track(true, true, TrackingEvents.SUMMARY, "Play By Play Click");
        },

        /* Player card */
        track_playercard: function () {
            track(true, true, TrackingEvents.PLAYER_CARD, "Player Card Access");
        },

        track_playercard_auto: function () {
            //track(false,false, TrackingEvents.PLAYER_CARD, "Situational Player Card");
        },

        /* Field tab */
        track_field_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.FIELD_VIEW);
        },
        track_field_activity: function () {
            track(true, true, TrackingEvents.FIELD_VIEW, "Field Activity");
        },

        track_odih_activity: function () {
            track(true, true, TrackingEvents.ON_DECK_IN_HOLE, "On Deck In Hole Lineups Activity");
        },
        
        track_jingle_activity: function ($jingle) {
           track(false, false, TrackingEvents.JINGLE, $jingle);
        },

        track_lineup_player_click: function () {
            track(true, true, TrackingEvents.ON_DECK_IN_HOLE, "Lineup Player Click");
        },

        track_on_deck_click: function () {
            track(true, true, TrackingEvents.ON_DECK_IN_HOLE, "On Deck Click");
        },

        track_on_deck_team_select: function () {
            track(true, true, TrackingEvents.ON_DECK_IN_HOLE, "Team Select Click");
        },

        track_in_hole_click: function () {
            track(true, true, TrackingEvents.ON_DECK_IN_HOLE, "In Hole Click");
        },

        track_on_field_lineups_activity: function () {
            track(true, true, TrackingEvents.ON_FIELD_LINEUPS, "On Field Lineups Activity");
        },

        /* Boxscore */

        track_box_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.SCORING);
        },
        track_box_tab_activity: function () {
            track(true, true, TrackingEvents.SCORING, TrackingEvents.SCORING + " Boxscore Tab");
        },

        track_box_anchor_activity: function () {
            track(true, true, TrackingEvents.SCORING, TrackingEvents.SCORING + " Boxscore Tab Anchor Link");
        },

        track_bench_tab_activity: function () {
            track(true, true, TrackingEvents.SCORING, TrackingEvents.SCORING + " Bench Tab");
        },

        /* Color */
        track_color_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.COLOR);
        },

        track_user_preferences_activity: function () {
            track(true, true, TrackingEvents.USER_PREFERENCES, "User Preferences Activity");
        },

        track_pitches_activity: function () {
            track(true, true, TrackingEvents.PITCH_VISUALIZATION, "Pitch Activity");
        },

        /* WRAPUP */
        track_wrapup_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.WRAPUP);
        },
        /* PREGAME */
        track_pregame_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.PREGAME);
        },

        /* Video tab and media*/
        track_video_tab_launch: function () {
            this.track_launch_click(true, true, TrackingEvents.HIGHLIGHTS);
        },

        track_video_list_click: function () {
            track(true, true, TrackingEvents.HIGHLIGHTS, "List Click");
        },

        track_video_collapse: function () {
            track(true, true, TrackingEvents.HIGHLIGHTS, "Change to PIP ");
        },

        track_video_expand: function () {
            track(true, true, TrackingEvents.HIGHLIGHTS, "Change to Takeover ");
        },

        track_video_media_view: function (mediaVO) {
            var mediaParams = { 
                media_streamId : mediaVO.id + " | " + mediaVO.defaultUrl.playback_scenario,
                media_playerType: "HTML5 Video",
                media_playerContext: "AtBat Real-Time Highlights",
                media_streamType: null,
                bitRate: mediaVO.defaultUrl.playback_scenario.split("_")[1],
                sequenceID: null,
                cdn: null,
                postRoll: false,
                media_playerFlavor: "2"  };
            track(true, true, TrackingEvents.HIGHLIGHTS, "Real-Time Highlight Viewed", mediaParams)
        },

        track_penguin_activity: function (isDynamicPageView, isUserGenerated, componentName, componentActivity) {
            track(isDynamicPageView, isUserGenerated, componentName, componentActivity);
        },
        
        track_color_feed_video_click: function () {
            track(false, true, TrackingEvents.HIGHLIGHTS + "AtBat: Social: Real-Time Highlights Click");
        },

        track_scoreboard_game_select: function(){
            track(true,true,TrackingEvents.SCOREBOARD, "Game Select")
        }


    }
});
